import { render, staticRenderFns } from "./CCompanyProgress.vue?vue&type=template&id=45af8ab0&scoped=true&"
import script from "./CCompanyProgress.vue?vue&type=script&lang=js&"
export * from "./CCompanyProgress.vue?vue&type=script&lang=js&"
import style0 from "./CCompanyProgress.vue?vue&type=style&index=0&id=45af8ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af8ab0",
  null
  
)

export default component.exports